(ns ductile.ui.agent.artifacts.damages
  (:require [clojure.string :as str]
            [ductile.ui.agent.policy :as agent.policy]
            [ductile.ui.components.table :as table]
            [ductile.ui.entry-protocol :as entry-protocol]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.routes :as routes]))

(defn- damage-photo-list
  [title damages]
  (when-let [photos (seq (filter :cas/multihash damages))]
    [:div.space-y-2
     [:div.text-xs.font-medium.text-slate-600 title]
     (for [[idx {:as damage :damage/keys [region kind description]}] (map-indexed vector photos)]
       ^{:key (str "damage-photo-" idx "-" (:cas/multihash damage))}
       [:div.flex.gap-3.items-start.rounded-lg.border.border-slate-200.bg-white.p-2
        [:img {:class "w-32 h-24 object-cover rounded border border-slate-200 flex-shrink-0"
               :src (routes/cas-path nil damage)}]
        [:div.text-xs.text-slate-700.min-w-0
         [:div.font-medium.break-words (str (or (tr region) region) " • " (or (tr kind) kind))]
         (when (and (string? description) (not (str/blank? description)))
           [:div.mt-1.text-slate-600.break-words description])]])]))

(defn view
  [{:keys [payload]} {:keys [dataset-data error-view]}]
  (let [dataset (some-> payload :dataset-id dataset-data)
        by-source (when (map? dataset) (:by-source dataset))
        by-source-value (fn [k]
                          (let [kk (agent.policy/attr-key-str->kw k)]
                            (or (get-in by-source [k :value])
                                (get-in by-source [kk :value]))))
        composite-entity (when (map? by-source)
                           {:vehicle/damages-outside (by-source-value ":vehicle/damages-outside")
                            :vehicle/damages-inside (by-source-value ":vehicle/damages-inside")
                            :fahrzeug/damages (by-source-value ":fahrzeug/damages")})
        entity (or (:fahrzeug payload)
                   composite-entity
                   (when (and (map? dataset) (not (contains? dataset :by-source))) dataset)
                   (when (and (sequential? dataset) (map? (first dataset))) (first dataset)))
        outside (:vehicle/damages-outside entity)
        inside (:vehicle/damages-inside entity)
        outside-count (count outside)
        inside-count (count inside)
        damage->row (fn [scope {:damage/keys [region kind description length]}]
                      {:scope scope
                       :region (or (tr region) region)
                       :kind (or (tr kind) kind)
                       :length (or length "")
                       :description (or description "")})
        damage-rows (vec (concat
                          (map #(damage->row (tr :vehicle/damages-outside) %) (or outside []))
                          (map #(damage->row (tr :vehicle/damages-inside) %) (or inside []))))]
    (if (map? entity)
      [:div.space-y-4
       [:div.flex.flex-wrap.items-center.gap-2.text-xs.text-slate-600
        [:span.inline-flex.items-center.rounded-full.bg-slate-100.px-2.py-1
         (str (tr :vehicle/damages-outside) ": " outside-count)]
        [:span.inline-flex.items-center.rounded-full.bg-slate-100.px-2.py-1
         (str (tr :vehicle/damages-inside) ": " inside-count)]]
       (when (seq outside)
         [:div.rounded-lg.border.border-slate-200.bg-slate-50.p-3
          [:div.text-xs.font-semibold.text-slate-700.mb-2 (tr :vehicle/damages-outside)]
          [:div {:class "max-w-[360px]"}
           [entry-protocol/diagram-selector {:diagram :explosion
                                             :damages outside}]]])
       (when (seq damage-rows)
         [:div {:class "overflow-x-auto max-w-full"}
          [table/table {:column-order [:region :kind :length :description :scope]
                        :translated-keys {:region (tr :damage/region)
                                          :kind (tr :damage/kind)
                                          :length (tr :damage/length)
                                          :description (tr :damage/description)
                                          :scope (tr :damage/scope)}}
           damage-rows]])
       (when (or (seq (filter :cas/multihash outside))
                 (seq (filter :cas/multihash inside)))
         [:div.rounded-lg.border.border-slate-200.bg-slate-50.p-3.space-y-3
          [:div.text-xs.font-semibold.text-slate-700 (tr "Photos")]
          [damage-photo-list (tr :vehicle/damages-outside) outside]
          [damage-photo-list (tr :vehicle/damages-inside) inside]])]
      [error-view {:error-message (tr "Damages artifact payload requires :fahrzeug map.")}])))
